/** For forms with complex string to number validation
 * In order to be accepted by the form, a number must be converted into a string,
 * but typed as a number in order to trick the form validation
 */
export const asStringNumber = (value: number): number => value.toString() as unknown as number

// Conversion functions
export const g_to_μg = (grams: number) => Math.round(grams * 1e6)

export const μg_to_g = (micrograms: number) => micrograms / 1e6

export const g_to_kg = (grams: number) => grams / 1e3

export const kg_to_g = (kilograms: number) => Math.round(kilograms * 1e3)

// Ready to use conversion handlers
export const g_as_μg = {
  prepare: g_to_μg,
  serialize: μg_to_g,
} as const

export const cents_per_g_as_cents_per_kg = {
  prepare: kg_to_g,
  serialize: g_to_kg,
} as const

// Store floats as integers with a fixed number of decimals

/** Force serialize as integer (round) */
export const integer = {
  prepare: (n: number) => Math.round(n),
  serialize: (n: number) => n,
} as const

export const euroField = {
  consume: (n: number) => n / 100,
  prepare: (n: number) => Math.round(n * 100),
} as const

/**
 * Colonnes `decimal`/`numeric` : `pg` les rend en chaîne, `consume` les convertit (sans mise à
 * l'échelle) pour que leur type `number` soit vrai à l'exécution. `decimalField` pour une colonne
 * non nulle, `nullableDecimalField` sinon. À ne pas confondre avec `twoDecimalField`, qui stocke
 * la valeur ×100 dans une colonne entière.
 */
export const decimalField = {
  consume: (value: string | number) => Number(value),
} as const

export const nullableDecimalField = {
  consume: (value: string | number | null) => (value === null ? null : Number(value)),
} as const

export const twoDecimalField = {
  consume: (n: number) => n / 100,
  prepare: (n: number) => Math.round(n * 100),
} as const
